import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { Link } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";
import { ProductKeyTypes } from "@/libraries/wpl/foundations/src/data-event-props";

import { TitleCard } from "../components/card";
import { useResourcesData, useResourcesLinks } from "../resources-subnav";

import { MobileNavTitle } from "./mobile-nav-card";

const mobileLinkListCss = css({
    listStyleType: "none",
    padding: 0,
    margin: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    li: {
        padding: `${token("space.100")} 0`
    }
});

export const MobileNavResources = ({
    productKey = "home"
}: {
    productKey?: ProductKeyTypes;
}) => {
    const intl = useIntl();

    const resourcesData = useResourcesData();
    const resourcesLinks = useResourcesLinks();
    const linkColumns = Object.values(resourcesLinks);

    return (
        <div>
            <MobileNavTitle
                title={intl.formatMessage({
                    id: "globalnav.v2.resources.title",
                    defaultMessage: "Resources"
                })}
            />

            {/* Main resource cards using desktop TitleCard component */}
            <div>
                {resourcesData.map(({ id, title, content, ...rest }) => (
                    <div key={id}>
                        <TitleCard
                            title={intl.formatMessage(title)}
                            content={intl.formatMessage(content)}
                            productKey={productKey}
                            {...rest}
                        />
                    </div>
                ))}
            </div>

            {/* Link sections */}
            {linkColumns.map((section) => (
                <div
                    key={section.id}
                    css={css({
                        background: wacToken("color.neutral.light100"),
                        margin: `0 ${token("space.negative.400")}`,
                        padding: token("space.400")
                    })}
                >
                    <div
                        style={{
                            margin: 0,
                            textTransform: "uppercase",
                            fontSize: "0.75rem"
                        }}
                    >
                        {intl.formatMessage(section.title)}
                    </div>
                    <ul css={mobileLinkListCss}>
                        {section.items.map((link) => (
                            <li key={link.id}>
                                {/* eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name */}
                                <Link
                                    type="anchor"
                                    href={link.href}
                                    text={intl.formatMessage(link.text)}
                                    ariaLabel={intl.formatMessage(link.text)}
                                    dataEventProps={{
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container":
                                            "globalNavSubnav",
                                        "data-product-key": productKey
                                    }}
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
};
